module.exports = __webpack_public_path__ + "static/media/vrb_white.c2e0087c.svg";